
define('text!presentation/developer/views/developer.html',[],function () { return '<nav class="main-navigation">\n\n</nav>\n';});

